import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority"
import { cn } from "../../lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        // default: "bg-primary text-primary-foreground hover:bg-primary/90",
        // destructive:
        //   "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        // outline:
        //   "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        // secondary:
        //   "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        // ghost: "hover:bg-accent hover:text-accent-foreground",
        // link: "text-primary underline-offset-4 hover:underline",

        "patient.default":
          "bg-background text-foreground  hover:bg-accent",

        "patient.primary":
          "bg-gradient-to-r from-[#ff9800] to-[#ff5722] text-white rounded-full hover:opacity-90",

        "patient.secondary":
          "bg-blue-500 text-white hover:opacity-90",

        "patient.tracery":
          "bg-gradient-to-r from-[#0a3d62] to-[#1e90ff] text-white font-bold",

        "patient.destructive":
          "bg-red-500 rounded-md font-bold px-4 py-2 hover:bg-opacity/90",

        "patient.ghost": 
          "hover:bg-accent text-foreground",

        "patient.link": 
          "text-blue-600 cursor-pointer  underline-offset-4 hover:underline",


        "admin.default":
          "bg-background text-foreground  hover:bg-accent",

        "admin.primary":
          "bg-[#0a1f44] text-white rounded-md hover:opacity-90",

        "admin.secondary":
          "bg-blue-500 text-white hover:opacity-90",

        "admin.tracery":
          "bg-yellow-400 text-black font-bold hover:opacity-90",

        "admin.destructive":
          "bg-red-500 rounded-md font-bold px-4 py-2 hover:bg-opacity/90",

        "admin.ghost": 
          "hover:bg-accent text-foreground",

        "admin.link": 
          "text-blue-600 cursor-pointer  underline-offset-4 hover:underline"

      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-10 rounded-md px-8",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button"
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    )
  }
)

Button.displayName = "Button"

export { Button, buttonVariants }